<app-header label="Home" sub_label="Configuration"></app-header>

<div class="h-[calc(100vh-100px)] bg-white shadow-md rounded-lg p-5">
  <form [formGroup]="form" (ngSubmit)="submit()">

    <!-- Main Card -->
    <div class="bg-white rounded-2xl flex flex-col min-h-[calc(100vh-150px)]">

      <!-- Body -->
      <div class="flex flex-1 p-6 gap-6">

        <!-- Left: Logo Upload -->
        <div class="flex flex-col items-center gap-3 w-[200px] flex-shrink-0">
          <app-file-uploader formControlName="logo_url" lebal="Logo" [is_required]="true" [accept]="'.jpg,.jpeg,.png'" [maxFileSize]="1" [uploaderVariant]="'photo-box'" class="w-full" [custom_format_error_msg]="'Please upload a valid logo (JPG/PNG, max 1 MB).'" [custom_size_error_msg]="'Please upload a valid logo (JPG/PNG, max 1 MB).'">
          </app-file-uploader>
          <p class="text-[0.65rem] text-gray-400 text-center">(200x200px, PNG, Jpeg, JPG Up To 1MB).</p>
        </div>

        <!-- Right: Form Fields -->
        <div class="flex-1 flex flex-col gap-4">

          <!-- Super Admin: University Dropdown -->
          <!-- <ng-container>
            <app-select-input [is_disabled]="gs.access_scope.locked.university" formControlName="university_id" label="University" [is_required]="true" [options]="university_options" (valueChange)="on_university_change($event)">
            </app-select-input>
          </ng-container> -->

          <!-- University Name (read-only) -->
          <app-text-input formControlName="university_name" [label]="'University Name'" [isRequired]="true"></app-text-input>
          <!-- Address Line 1 -->
          <app-text-input formControlName="address_line1" [label]="'Address line 1'" [isRequired]="true" [custom_required_error_msg]="'Please enter a valid university address.'" [custom_min_error_msg]="'Please enter a valid university address.'" [custom_max_error_msg]="'Please enter a valid university address.'"></app-text-input>
          <!-- Address Line 2 -->
          <app-text-input formControlName="address_line2" [label]="'Address line 2'" [custom_required_error_msg]="'Please enter a valid university address.'" [custom_min_error_msg]="'Please enter a valid university address.'" [custom_max_error_msg]="'Please enter a valid university address.'"></app-text-input>

          <!-- GST Required Row -->
          <div class="flex flex-col gap-2">
            <!-- Label line -->
            <div class="flex items-center gap-1 flex-wrap">
              <span class="text-sm font-normal text-[#212121]">GST required<span class="text-red-500">*</span></span>
              <span class="text-xs italic text-[#666666]">Select if GST is required, if yes GSTIN Number is mandatory.</span>
            </div>
            <!-- Controls line -->
            <div class="flex items-center gap-4">
              <div class="h-12 flex items-center">
                <app-radio formControlName="gst_required" layout="horizontal" [options]="[{label: 'Yes', value: 'yes'}, {label: 'No', value: 'no'}]"></app-radio>
              </div>
              <app-text-input *ngIf="gst_required === 'yes'" formControlName="gstn" [label]="'GSTIN'" [isRequired]="true" class="w-[249px]">
              </app-text-input>
            </div>
          </div>

          <!-- Signatory Name + Designation (two columns) -->
          <div class="grid grid-cols-2 gap-4">
            <app-text-input formControlName="signatory_name" [label]="'Authorized Signatory Name'" [isRequired]="true">
            </app-text-input>

            <app-text-input formControlName="designation" [label]="'Designation'" [isRequired]="true">
            </app-text-input>
          </div>

          <!-- Signature Image Upload -->
          <app-file-uploader formControlName="signature_url" [accept]="'.jpg,.jpeg,.png'" [maxFileSize]="1" lebal="Signature Image (Upload)" [is_required]="true" sub_text="Supported: .Jpeg, .Jpg, .Png, Max: 1MB"></app-file-uploader>

        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="flex justify-end items-center gap-3 px-3 pt-4 bottom-0 sticky bg-white">
        <button type="button" (click)="gs.go_back()" class="px-6 py-2.5 text-sm  text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-50 transition-colors">
          {{gs.user_role_data.admin_configuration_update ? 'Discard' : 'Back'}}
        </button>
        <button *ngIf="gs.user_role_data?.admin_configuration_update" type="submit" [disabled]="isSubmitting" class="px-8 py-2.5 text-sm  text-white bg-[#3F41D1] rounded-full hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors">
          {{ isSubmitting ? 'Saving...' : 'Save' }}
        </button>
      </div>

    </div>

  </form>
</div>